import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppService } from '@App';
import { IConfigService } from '@Config';
import { BaseService } from '@Services';
import { IDashboardTask } from '@CaseSummary/underwriting/models/uw-task.model';
import { DropdownOption } from '@Components/single-select-dropdown-list/single-select-dropdown-list.component';
import { User } from '@Models';

@Injectable({
    providedIn: 'root'
})
export class DashboardTasksDataService extends BaseService {
    private readonly publicApiBaseUrl: string;

    constructor(
        public appService: AppService,
        public httpClient: HttpClient,
        public configService: IConfigService
    ) {
        super(appService, configService, httpClient);
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    getMyTasks(userId: string, hideWaiting: boolean = false): Observable<IDashboardTask[]> {
        return super.getData<IDashboardTask[]>(
            `${this.publicApiBaseUrl}user/${userId}/tasks/assigned`,
            null,
            hideWaiting
        );
    }
    
    getAccountUsers(clientId: string, accountId: string, caseId: string, hideWaiting = false): Observable<DropdownOption[]> {
        return super.getData<User[]>(
            `${this.publicApiBaseUrl}client/${clientId}/account/${accountId}/case/${caseId}/assignees/`,
            null,
            hideWaiting
        ).pipe(
            map(users => users.map(u => ({
                value: u.id,
                displayName: `${u.firstName} ${u.lastName}`
            })))
        );
    }
}

